import { BASE_URL } from "@/utils";
import { AxiosRequestConfig } from "axios";
import getToken from "@/utils/getToken";
import getAxiosObj from "@/utils/request";

export interface XApeStrategyList {
    x_aper_strategy_id: number,
    handle: string,
    chain: string
    name: string
    amount_native_buyin: number
    slippage_allowed: number
    filter_mc_type: number
    filter_mc_value1: number
    filter_mc_value2: number
    filter_vol_30min_type: number
    filter_vol_30min_value1: number
    filter_vol_30min_value2: number
    filter_vol_4h_type: number
    filter_vol_4h_value1: number
    filter_vol_4h_value2: number
    filter_vol_24h_type: number
    filter_vol_24h_value1: number
    filter_vol_24h_value2: number
    tp_profit_percentage: number
    tp_sell_percentage: number
    sl_loss_percentage: number
    sl_sell_percentage: number
    also_ape_tickers: number
}


export const getMyXApeStrategies = async () => {
    let url = `${BASE_URL}/bro/GetXApeStrategies`
    const config: AxiosRequestConfig = {
        headers: {
            "Authorization": `Bearer ${getToken()}`
        },
        maxBodyLength: Infinity,
        method: "GET",
        url,
    };

    const axiosObj = getAxiosObj();
    const response = await axiosObj<any>(config);
    return response.data;
}